import { graphql, useStaticQuery } from "gatsby";
    import { PatstoreDownload } from '@types';

const useGetDownload = () => {
    const data = useStaticQuery(graphql`
        query AllDownload {
            allPatstoreDownload {
                edges {
                    node {
                        id
                        
            objectId
    categories
    label
    title
    createdAt
    text
    gallery
    date
    state
    file  
  localFile {
            id  
            absolutePath
            url
            publicURL
            childImageSharp {
                gatsbyImageData(
                    width: 1920
                    placeholder: BLURRED
                    formats: [WEBP]
                )
            }
        }
    image
    description
    
                    }
                }
            }
        }
    
        `);


    const allDownload: PatstoreDownload[] =
        data.allPatstoreDownload.edges.map(
            (edge: { node: PatstoreDownload }) => edge.node
        ) || [];

    const findDownload: (id: string) => PatstoreDownload | undefined = (id: string) => {
        const result = allDownload.find((item: PatstoreDownload) => item.objectId === id);

        if (!result) {
            return undefined;
        }

        return result;
    };

    return {
        findDownload,
        downloads: allDownload,
    };
}; 

export default useGetDownload;
